export default __webpack_public_path__ + "static/media/dark-signout-icon.e61130d2.svg";